import React, {useState, useEffect} from 'react';

//import {Modal, Button} from 'react-bootstrap';

//import 'bootstrap/dist/css/bootstrap.min.css';

const InvitationModal = ({toggleShow, btnClose, btnTeamInvite, inputEmail, txtemail, btninvitespin}) =>{

    //const [show, setShow] = useState(false);
    //console.log('Invitation modal');

    return(
    <>
    <div className={toggleShow ? 'modal fade show' : 'modal fade' } id="exampleModalScrollable2" tabindex="-1" aria-labelledby="exampleModalScrollable2" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="staticBackdropLabel2">Invite Caller</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={btnClose}></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label htmlFor="email" className="form-label">Email*</label>
                        <input className="form-control" type="email" id="email" name="email" value={txtemail} required="" placeholder="Enter email address" onChange={inputEmail} />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={btnClose}>Close</button>

                    {btninvitespin ?
                        <button type="button" class="btn btn-primary"> 
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </button>
                    :
                        <button type="button" class="btn btn-primary" onClick={btnTeamInvite}> Delete </button>
                    }
                </div>
            </div>
        </div>
    </div>
    {/*<Modal show={toggleShow} onHide={btnClose}>

        <Modal.Header closeButton>

          <Modal.Title>Invite Team</Modal.Title>

        </Modal.Header>
        
        <Modal.Body>
                <div class="mb-3">
                    <label htmlFor="email" className="form-label">Email*</label>
                    <input className="form-control" type="email" id="email" name="email" value={txtemail} required="" placeholder="Enter email address" onChange={inputEmail} />
                </div>

        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={btnClose}> Close </Button>

            {btninvitespin ?
                <Button variant="primary"> 
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </Button>
            :
                <Button variant="primary" onClick={btnTeamInvite}> Invite </Button>
            }

        </Modal.Footer>
    </Modal>*/}
    </>
    );
}

export default InvitationModal;
